import styled, { keyframes } from "styled-components";
import { theme } from "../../../styles/theme";

// Animação para o efeito de pulsar do anel neon
const pulseRing = keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 224, 255, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 224, 255, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 224, 255, 0);
  }
`;

// Animação de rotação para o anel externo
const rotateGlow = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Animação para fazer o avatar flutuar levemente
const float = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
`;

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0;

  @media (min-width: 768px) {
    flex-direction: column;
    text-align: center;
    margin: 0 auto;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
  margin-bottom: 1.5rem;
  animation: ${float} 6s ease-in-out infinite;

  @media (min-width: 768px) {
    width: 240px;
    height: 240px;
  }

  &::before {
    content: "";
    position: absolute;
    top: -8px;
    left: -8px;
    right: -8px;
    bottom: -8px;
    border-radius: 50%;
    background: ${theme.colors.buttonGradient};
    z-index: -1;
    animation: ${pulseRing} 3s infinite;
  }

  &::after {
    content: "";
    position: absolute;
    top: -15px;
    left: -15px;
    right: -15px;
    bottom: -15px;
    border-radius: 50%;
    border: 2px solid ${theme.colors.secondary};
    z-index: -2;
    animation: ${rotateGlow} 10s linear infinite;
    box-shadow: 0 0 20px ${theme.colors.secondary},
      inset 0 0 20px ${theme.colors.secondary};
    opacity: 0.7;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid transparent;
    background-clip: padding-box;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;
  }
`;

export const ProfileInfo = styled.div`
  max-width: 600px;
  margin-top: 1rem;
`;

export const ProfileName = styled.h1`
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 0.3rem;
  background: linear-gradient(to right, #00a3ff, #00e0ff, #ffffff);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  letter-spacing: 0.5px;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const ProfileRole = styled.h2`
  font-size: 1.6rem;
  font-weight: 500;
  color: ${theme.colors.primary};
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const ProfileDescription = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  color: ${theme.colors.textSecondary};
  margin-bottom: 1rem;
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
`;

export const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 2rem;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: rgba(0, 163, 255, 0.1);
    color: ${theme.colors.primary};
    font-size: 1.5rem;
    transition: ${theme.transitions.default};

    &:hover {
      background: ${theme.colors.primary};
      color: white;
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 163, 255, 0.4);
    }
  }
`;

export const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem 2rem;
  background: ${theme.colors.buttonGradient};
  border-radius: ${theme.borderRadius.full};
  color: white;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: ${theme.transitions.default};
  position: relative;
  overflow: hidden;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 163, 255, 0.3);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      120deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transform: translateX(-100%);
    transition: 0.6s;
  }

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 163, 255, 0.5);
    transform: translateY(-2px);

    &::before {
      transform: translateX(100%);
    }
  }

  i,
  svg {
    margin-right: 0.5rem;
    font-size: 1.2rem;
  }
`;
